import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { created_incident_number } from '../../redux/commonReducer';

export default function ThanksPage() {

    const { t } = useTranslation();
    const incident_number = useSelector(created_incident_number)

    return (
        <div className='ThanksPage'>
            <img className='tick' src="./assets/img/icons/Icon awesome-check-circle.svg" alt="" />
            <h2>{t('thank_you')}</h2>
            <p>{t('incident_no')}: <strong>{incident_number}</strong></p>
            <p>{t('you_shall_receive_an_sms_with_reference_id')}</p>
            <Link className='next-button' to={'/'} rel="noreferrer">
                <img className='arrow left' src="./assets/img/icons/Icon awesome-arrow-right.svg" alt="" />
                {t('back_to_home_page')}
            </Link>
        </div>
    )
}
